import { TransformPlainObject } from './transform.plainObject';
import { SortExpressionPlainObject } from './sortExpression.plainObject';

export class BaseSortPlainObject extends TransformPlainObject {
    public sortExpressions: SortExpressionPlainObject[] = [];
}
